import { useEffect, useRef, useState } from 'react';

import type React from 'react';

export interface FilterOption {
  value: string;
  label: string;
}

export function FilterChip({
  label,
  options,
  value,
  onChange,
}: {
  label: string;
  options: FilterOption[];
  value: string | undefined;
  onChange: (value: string | undefined) => void;
}): React.JSX.Element {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    function onDocClick(e: MouseEvent): void {
      if (ref.current !== null && !ref.current.contains(e.target as Node)) setOpen(false);
    }
    document.addEventListener('mousedown', onDocClick);
    return () => {
      document.removeEventListener('mousedown', onDocClick);
    };
  }, [open]);

  const selected = value !== undefined ? options.find((o) => o.value === value) : undefined;
  const chipLabel = selected !== undefined ? `${label}: ${selected.label}` : label;

  function pick(v: string | undefined): void {
    onChange(v);
    setOpen(false);
  }

  return (
    <div className="ti-filter" ref={ref}>
      <button
        type="button"
        className={'chip' + (value !== undefined ? ' chip--active' : '')}
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => {
          setOpen((o) => !o);
        }}
      >
        {chipLabel} <span className="chip__caret">▾</span>
      </button>
      {open && (
        <div className="ti-filter__menu" role="listbox">
          <button
            type="button"
            role="option"
            aria-selected={value === undefined}
            className="ti-filter__opt"
            onClick={() => {
              pick(undefined);
            }}
          >
            Todos
          </button>
          {options.map((o) => (
            <button
              key={o.value}
              type="button"
              role="option"
              aria-selected={o.value === value}
              className={'ti-filter__opt' + (o.value === value ? ' ti-filter__opt--active' : '')}
              onClick={() => {
                pick(o.value);
              }}
            >
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
